"use client"

import { useState } from "react"
import { useDropzone } from "react-dropzone"
import { BiCheckCircle, BiX, BiUpload, BiFile } from "react-icons/bi"
import * as XLSX from "xlsx"

export default function DataImportForm({ visibleChamps, setDataInput }) {
    const [errors, setErrors] = useState({})
    const [previewHeaders, setPreviewHeaders] = useState([])
    const [fileName, setFileName] = useState(null)

    const headersColumns = visibleChamps.map((c) => c.nom_ligne)

    const validateHeaders = (fileHeaders) => {
        const missing = headersColumns.filter((h) => !fileHeaders.includes(h))
        if (missing.length > 0) {
            setErrors({ headers: `Colonnes manquantes : ${missing.join(", ")}` })
            return false
        }
        setErrors({})
        return true
    }

    const processFile = (file) => {
        const reader = new FileReader()
        reader.onload = (evt) => {
            const bstr = evt.target.result
            const wb = XLSX.read(bstr, { type: "binary" })
            const wsname = wb.SheetNames[0]
            const ws = wb.Sheets[wsname]
            const data = XLSX.utils.sheet_to_json(ws, { header: 1 })

            const fileHeaders = data[0] || []
            setPreviewHeaders(fileHeaders)

            if (validateHeaders(fileHeaders)) {
                const rows = XLSX.utils.sheet_to_json(ws, { defval: "" })
                const keyRows = rows.map(({ __rowNum__, ...rest }) => ({ key_data: __rowNum__, ...rest }))
                setDataInput(keyRows)
                setFileName(file.name)

            }
        }
        reader.readAsBinaryString(file)
    }

    const onDrop = (acceptedFiles) => {
        const file = acceptedFiles[0]
        if (!file) return
        processFile(file)
    }

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
            "application/vnd.ms-excel": [".xls"],
            "text/csv": [".csv"],
        },
        multiple: false,
    })

    const handleResetImport = () => {
        setDataInput([])
        setFileName(null)
        setPreviewHeaders([])
        setErrors({})
    }

    return (
        <div>
            <div
                {...getRootProps()}
                className={`rounded-1 p-3 text-center transition bg-light ${isDragActive ? "border-info" : "border-body"
                    }`}
                style={{ cursor: isDragActive ? "not-allowed" : "pointer", borderStyle: "dashed", borderColor: "#dee2e6" }}
            >
                <input {...getInputProps()} />
                <BiUpload size={32} className="text-muted mb-3" />
                {isDragActive ? (
                    <p className="mb-0 fw-bold text-info">Déposez votre fichier ici...</p>
                ) : (
                    <p className="mb-0 text-muted">
                        Glissez-déposez un fichier <strong>.csv, .xlsx, .xls</strong> <br />
                        ou cliquez pour parcourir
                    </p>
                )}
            </div>

            {/* ✅ Nom fichier importé */}
            {fileName && (
                <div className="mt-3 small d-flex align-items-center justify-content-center text-success fw-bold">
                    <BiFile className="me-1" /> {fileName} importé avec succès
                </div>
            )}

            {/* ✅ Erreurs */}
            {errors.file && <div className="text-danger small mt-3">{errors.file}</div>}
            {errors.headers && <div className="text-danger small mt-3">{errors.headers}</div>}

            {/* ✅ Aperçu des colonnes */}
            {previewHeaders.length > 0 && (
                <div className="alert alert-light small p-2 my-4 rounded-1">
                    <strong>Colonnes détectées :</strong> {previewHeaders.join(", ")}
                </div>
            )}

            <div className="d-flex justify-content-end gap-2 mt-4">
                <button onClick={() => handleResetImport()} type="button" className="btn btn-sm btn-light px-2 d-flex align-items-center">
                    <BiX className="me-1" /> Reinitialiser
                </button>
            </div>
        </div>
    )
}
